export default __webpack_public_path__ + "static/media/Graph.7318c071.png";